import { useEffect, useState } from "react";
import AddNewInsurance from "../Setup/InsuranceM/Insurance/AddNewInsurance";
import AddNewBillingProvider from "../Setup/Account/BillingProvider/AddNewBillingProvider"
import useHandleOpenNewBrowserTab from "../shared/NewTabBrowser/useHandleOpenNewBrowserTab";
import AddNewRefProvider from "../Setup/Account/RefProvider/AddNewRefProvider";
import AddNewDocumentType from "../Billing/Claims/ClaimDetails/Documnet/AddNewDocumentType";

const HandleValidationError = (props) => {
    let {screenName,fieldName,setErrorPopup,row,handleOpenNewBrowserTab} = props;
    const [ popupScreen, setPopupScreen] = useState("");
    // const [ typeID, setTypeID] = useState(0);
    const [ IsOpenPopup, setIsOpenPopup] = useState(false);
    const handlePopup = () => {
        // setTypeID(0);
        let screenNames = screenName.split("->")
        if(screenNames.length === 1){
            handleScreenType("single");
        } else if(screenNames.length === 2){
            handleScreenType("double");
        }
    }

    const handleObj = (name,dataProp) => {
        return ({ 
            key: 2,
            name: name,
            active: true,
            data: {
                id: row?.id,
                ...dataProp,
                time: new Date(),
            },
        })
    }
    const handleScreenType = (type) => {
        if(type === "single"){
            let dataClaim = handleObj('Claims',{
                name: "Claim",
                VisitType: "I", ////Fix type => needs to be coming dynamically////
            });
            let dataPatient = handleObj('Patient',{
                name: "Patient",
             });
            console.log("screenName",screenName,row?.id)
            switch(screenName){
                case 'Claim':
                    handleOpenNewBrowserTab(dataClaim);
                break;
                case 'Claims':
                    handleOpenNewBrowserTab(dataClaim);
                break;
                case 'Patient':
                    handleOpenNewBrowserTab(dataPatient);
                break;
            }
            setErrorPopup(<></>);
        }
        if(type === "double"){
            console.log(screenName)
            let screenNames = screenName.split("->");
            console.log("screenNames",screenNames)
            let dataPatient = {
                key: 2,
                active : true,
                name:'Patient',
                data: {
                    id: row?.id,
                    name: "Patient",
                    time: new Date(),
                }
            };
            switch(screenNames[1]){
                case 'Insurance':
                setPopupScreen(<AddNewInsurance IsOpenInsurance={IsOpenPopup} onClose={ClosePopup} onDeleteInsurance={ClosePopupRefresh} InsuranceID={row?.id ? row.id : 0} />);
                break;
                
                case 'Billing Provider':
                setPopupScreen(<AddNewBillingProvider IsOpenBillingProvider={IsOpenPopup} onClose={ClosePopup} onDeleteBillingProvider={ClosePopupRefresh} BillingProviderID={row?.id ? row.id : 0} />);
                break;
                
                case 'Ref Provider':
                setPopupScreen(<AddNewRefProvider isOpenRefProvider={IsOpenPopup} onClose={ClosePopup} onDeleteProvider={ClosePopupRefresh} RefProviderID={row?.id ? row.id : 0} />);
                break;
                
                case 'Document Type':
                setPopupScreen(<AddNewDocumentType isOpenDocumentType={IsOpenPopup} onClose={ClosePopup} onDeleteDocumentType={ClosePopupRefresh} DocumentTypeID={row?.id ? row.id : 0} setisDocumetTypeSaved={()=>{}}/>);
                break;
            }
            // switch(screenNames[0]){
            //     case 'Patient':
            //         handleOpenNewBrowserTab(data);
            //     break;
            // }
            if(screenNames[0]==='Patient'){handleOpenTab(dataPatient)};
        }
        handleOpenPopup(); 
    }
    /////////////////////
    const handleOpenPopup = () => {
        setIsOpenPopup(true)
    }
    /////////////////////
    const handleOpenTab = (data)=>{
        handleOpenNewBrowserTab(data);
        setErrorPopup(<></>);
    }
    const ClosePopup = () => {
        setIsOpenPopup(false)
        setErrorPopup(<></>)
    }
    const ClosePopupRefresh = () => {
        setIsOpenPopup(false)
        setErrorPopup(<></>)
        if(props.handlePerformReloadFunction){ props.handlePerformReloadFunction(); }
    }

    let PopupScreen = "";
    if (IsOpenPopup) {
        PopupScreen = popupScreen;
    }
    /////////////////////////
    useEffect(()=>{ handlePopup();},[screenName,fieldName])
    useEffect(()=>{IsOpenPopup && handlePopup();},[IsOpenPopup])
    /////////////////////////
    return (<>
    {PopupScreen}
    </>  );
}
 
export default HandleValidationError;